import React, {useState} from 'react';
import {BaseRequest} from "../utils/Classes/Requests/BaseRequest";
import useMerchantPortalAxios from "../utils/axios";


export const useExchangeApi = () => {
    const [exchangeRate, setExchangeRate] = useState(null);
    const [exchangeHistory, setExchangeHistory] = useState(null);
    const [exchangeHistoryLoading, setExchangeHistoryLoading] = useState(true);
    const [totalNbPage, setTotalNbPage] = useState(0);

    const MerchantPortalClient = useMerchantPortalAxios();

    async function getExchangeRate() {
        const req = new BaseRequest(
            sessionStorage.getItem("SessionID")
        );

        const res = await MerchantPortalClient.post(
            `/v1/Exchange/GetExchangeRate`,
            req
        );

        setExchangeRate(res.data.Payload);
    }


    async function getExchangeHistory(type, startDate, endDate) {
        const res = await MerchantPortalClient.post(
            '/v1/Exchange/GetExchangeHistory',
            {
                SessionID: sessionStorage.getItem("SessionID"),
                ExchangeType: type,
                DateFrom: startDate,
                DateTo: endDate
            }
        )
        if (res.status === 200) {
            setExchangeHistory(res.data.Payload.ExchangeHistoryList);
            setTotalNbPage(res.data.Payload.ExchangeHistoryList?.length);
            setExchangeHistoryLoading(false);
        }
    }

    const InitiateExchange = async (payload) => {
        const res = await MerchantPortalClient.post(`/v1/Exchange/InitiateExchange`, payload);

        return res.data.Payload;
    };

    return {
        getExchangeHistory,
        getExchangeRate,
        InitiateExchange,
        exchangeRate,
        exchangeHistory,
        exchangeHistoryLoading,
        totalNbPage
    }

}
